import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import { Alert, Box } from "@mui/material";
import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";
import CardActions from "./components/CardActions";
import CardViewer from "./components/CardViewer";
import { CardProvider } from "./components/CardContext";
import { getAchBankAccount } from "../../api/paymentMethodsService";
import { useDispatch } from "react-redux";
import { resetTransferAmount, setCardBank } from "../../redux/slices/cardSlice";
import CardActionsSkeleton from "./components/CardActionsSkeleton";
import { CardBankWrapper } from "../../types/paymentTypes";

import { Version } from "sass";
const CardDetailsPage: React.FC = () => {
  const { provider } = useParams<{ provider: string }>();

  if (!provider) {
    return <div>Payment method not found</div>;
  }

  // const { loading, data, error } = useAPI<CardBankWrapper>(getAchBankAccount());
  // const dispatch = useDispatch();

  // useEffect(() => {
  //   dispatch(resetTransferAmount());
  // }, []);

  // useEffect(() => {
  //   const bankDetails = data?.externalBankAccountDetails;
  //   if (!bankDetails) return;
  //   dispatch(setCardBank(bankDetails));
  // }, [data]);

  return (
    <CardProvider>
      <Box>
        <CardViewer provider={provider} />

        <CardActions provider={provider} />
      </Box>
    </CardProvider>
  );
};

export default CardDetailsPage;
